import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  helpContentText: {
    defaultMessage:
      'Upload a CSV file to import totes. Need help formatting? <file>Download our sample CSV file</file> or <helpLink>learn more about importing a CSV.</helpLink>',
    id: 'W4nfXX',
    description: 'Location Import help content text',
  },
  uploadFile: {
    id: '8cjYM6',
    defaultMessage: 'Upload File',
    description: 'Title for the first step of the import process',
  },
  selectInventoryWarehouseHeader: {
    defaultMessage: 'Select Warehouse',
    id: 'n8e9bC',
    description: 'Header text for warehouse selection dropdown',
  },
  selectInventoryWarehouse: {
    defaultMessage: 'Choose a warehouse',
    id: 'TQAl/u',
    description: 'Placeholder text for warehouse selection dropdown',
  },
});
